<template>
  <div
    class="stt scroll-right-overlay"
    style="--clr-scrl-back: var(--clr-black-1); --scrl-width: 1rem"
  >
    <div
      class="stt_inner no-scroll-track"
      @wheel.stop="e => wheelScroll(e)"
    >
      <div
        v-if="hasPlayers"
        class="stt_players"
      >
        <PokerPlayer
          v-for="player in players"
          :key="player.name"
          class="player_square"
          :player="player"
          :hasTimetravel="true"
          :isSquare="true"
          :hasAction="false"
          :hasCards="false"
          style="
            --clr-hero: var(--clr-hero-default);
            --clr-trainer_player_active: var(--clr-black-3);
            --clr-trainer_player_folded: var(--clr-black-1-2);
          "
        >
        </PokerPlayer>
      </div>
      <div class="stt_pot">
        <div
          class="d-flex"
          style="gap: 0.5rem"
        >
          <div
            v-show="pot"
            class="stt_pot_table text-nowrap"
          >
            {{ numFixedUnit(pot, 'bb') }} BB
          </div>
          <div
            v-show="start_pot"
            class="stt_pot_street weight_500 text-medium clr-grey text-nowrap"
          >
            {{ numFixedUnit(start_pot, 'bb') }} BB
          </div>
        </div>
        <div
          v-show="pot_odds"
          class="stt_pot_odds d-flex csst cursor-default"
          style="gap: 0.5rem"
          @mouseenter="e => fl_positionTooltip(e, { offset: 0, placement: 'bottom' })"
        >
          <div class="text-smallest weight_6700 clr-grey text-nowrap">
            {{ $t('common.pot_odds_is') }}
          </div>
          <div class="stt_pot_street weight_500 text-medium clr-grey text-nowrap">
            {{ pot_odds ? `${numFixedUnit(pot_odds * 100, 'pot_odds')}%` : '-' }}
          </div>
          <div
            class="csst_content csst_content_hoverable text-nowrap"
            style="position: fixed"
            v-html="
              $t('tooltips.what_is_pot_odds', {
                linkText: !$i18n.g1
                  ? `</br><a target='_blank' class='weight_700 link-underline' href='${links_url_links.what_is_pot_odds.url}'>${links_url_links.what_is_pot_odds.text}</a>`
                  : '',
              })
            "
          ></div>
        </div>
      </div>

      <CardRow
        v-if="hand"
        class="stt_item my-auto mr-auto"
        :cards="hand"
        :size="mobile ? 'small' : 'medium'"
        :cardStyle="mobile ? '' : '--height:2.5em'"
        :hasAnimation="false"
      />

      <CardRow
        v-if="!usingCustomReports"
        class="stt_item my-auto mr-auto"
        :cards="board"
        :size="mobile ? 'small' : 'medium'"
        :cardStyle="mobile ? '' : '--height:2.5em'"
        :hasAnimation="false"
      />
    </div>
    <slot />
  </div>
</template>

<script>
import { getPlayersDefault } from '@/store/gamestate/gamestate'
import CardRow from '@/components/CardRow/CardRow'
import PokerPlayer from '@/components/PokerTable/PokerPlayer'

import horizontalScroll_mix from '@/components/HorizolnalScroller/horizontalScroll_mix'
import float_mix from '@/mixins/float_mix'
import format_mix from '@/mixins/format_mix'
import links_mix from '@/mixins/links_mix'
import { sortByPosition } from '@/helpers/helpers'

export default {
  name: 'StudyTableTile',
  components: {
    CardRow,
    // MenuBubbleFactor,
    PokerPlayer,
  },
  mixins: [horizontalScroll_mix, format_mix, float_mix, links_mix],
  props: {
    hSpot: Object,
    gameformat: Object,
    street: String,
    mobile: Boolean,
    hasPlayers: { type: Boolean, default: true },
    hasEmptyFlopBoard: { type: Boolean, default: false },
    hand: String,
    solElite: Object,
    usingCustomReports: Boolean,
  },
  computed: {
    pot() {
      return this.hSpot?.pot || 0
    },
    start_pot() {
      return this.hSpot?.start_pot || 0
    },
    pot_odds() {
      return this.hSpot?.pot_odds || 0
    },
    board() {
      return this.hasEmptyFlopBoard
        ? 'EeEeE'
        : this.hSpot?.board || this.$store.getters.street_board_any(this.street).join('')
    },
    players() {
      let players = this.hSpot?.players || []
      if (this.solElite?.want_use) {
        if (this.$store.getters.user_has_flag?.('SOL_3WAY')) {
          players = players.sort((a, b) =>
            sortByPosition(a.relative_postflop_position, b.relative_postflop_position),
          )
        } else {
          const playerIP = players.find(i => i.relative_postflop_position === 'IP') || {
            position: 'IP',
            relative_postflop_position: 'IP',
            current_stack: 100,
          }
          const playerOOP = players.find(i => i.relative_postflop_position === 'OOP') || {
            position: 'OOP',
            relative_postflop_position: 'OOP',
            current_stack: 100,
          }
          players = [playerOOP, playerIP]
        }
      }
      players =
        players ||
        getPlayersDefault({
          // customTree: this.solElite?.cTree,
          gameformat: this.gameformat,
        })
      players = players.map(i => ({
        ...i,
        chips_on_table: 0,
        hand: '',
      }))
      return players
    },
  },
}
</script>
<style lang="scss" scoped>
.stt {
  flex: 1;
  min-height: 2.325rem;
  min-width: 0;
  display: flex;

  flex-shrink: 0;
  overflow: hidden;
  position: relative;

  &_item {
    order: 1;
  }
  // &_reversed {
  //   .stt_players {
  //     order: 3;
  //   }
  //   .stt_pot {
  //     order: 2;
  //   }
  // }
  &_centered {
    align-items: center;
    justify-content: center;
  }
  &_inner {
    position: relative;
    display: flex;
    flex-shrink: 0;
    min-width: 0;
    min-height: 0;
    grid-gap: 1rem;
    padding: 0 1rem 0 0rem;
    max-width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
  }
  &_players {
    margin: 0 0 0 auto;
    display: flex;
    grid-gap: 0.25rem;
    flex-shrink: 0;
  }
  &_pot {
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    &_table {
      font-size: 0.875rem;
      font-weight: 700;
    }
    &_street {
      font-size: 0.875rem;
      text-align: center;
      font-weight: 700;
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 1.2;
    }
  }
}

@media (max-width: 1023px) {
  .stt_inner {
    padding: 0 1rem 0 0.125rem;
    .stt_players {
      order: 3;
    }
    .stt_pot {
      order: 2;
    }
  }
}
</style>
